var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "body",
      {
        staticClass:
          "home page-template-default page page-id-314 wp-embed-responsive st-Grid_Container",
        staticStyle: { "overflow-y": "unset" },
        attrs: { "data-anchor": "pagetop" }
      },
      [
        _c("navbar", {
          attrs: {
            follow: "st-Header",
            imgSrc: "../../../../static/img/logo/logo-black.png"
          }
        }),
        _vm._v(" "),
        _c("div", { staticClass: "st-FixedPoint" }),
        _vm._v(" "),
        _c("div", { staticClass: "st-MainContainer" }, [
          _c(
            "main",
            {
              staticClass: "st-MainContents",
              staticStyle: { "padding-top": "120px" }
            },
            [
              _vm._m(0),
              _vm._v(" "),
              _c("section", { staticClass: "company-Profile" }, [
                _c("div", { staticClass: "company-Profile_Inner" }, [
                  _vm._m(1),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "company-Profile_List company-profile-appear-4",
                      attrs: { "data-appear": "true" }
                    },
                    [
                      _c("dl", [
                        _c("dt", [_vm._v("会社名")]),
                        _vm._v(" "),
                        _c("dd", [
                          _c(
                            "div",
                            { staticClass: "company-Profile_List-block" },
                            [
                              _c("router-link", { attrs: { to: "/" } }, [
                                _c(
                                  "p",
                                  { staticClass: "company-Profile_List-text" },
                                  [
                                    _vm._v(
                                      "株式会社ロボティクスソリューションズ"
                                    ),
                                    _c("br"),
                                    _vm._v(
                                      "\n                      （英語名Robotics Solutions Co.,Ltd.）\n                      "
                                    )
                                  ]
                                )
                              ])
                            ],
                            1
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _vm._m(2),
                      _vm._v(" "),
                      _vm._m(3),
                      _vm._v(" "),
                      _vm._m(4),
                      _vm._v(" "),
                      _vm._m(5),
                      _vm._v(" "),
                      _vm._m(6),
                      _vm._v(" "),
                      _vm._m(7),
                      _vm._v(" "),
                      _vm._m(8)
                    ]
                  )
                ])
              ]),
              _vm._v(" "),
              _vm._m(9),
              _vm._v(" "),
              _c("section", { staticClass: "company-Profile" }, [
                _c("div", { staticClass: "company-Profile_Inner pt-0" }, [
                  _vm._m(10),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "common-appear company-profile-appear-6",
                      attrs: { "data-appear": "true" }
                    },
                    [
                      _c("font", [
                        _c("p", { staticClass: "company-Profile_List-text" }, [
                          _vm._v(
                            "JR・山手線・京浜東北線 浜松町駅　徒歩2分\n                  "
                          ),
                          _c("br"),
                          _vm._v(
                            "\n                  都営・浅草線・大江戸線 大門駅 徒歩2分\n                "
                          )
                        ]),
                        _vm._v(" "),
                        _c("br"),
                        _vm._v(" "),
                        _c("br")
                      ]),
                      _vm._v(" "),
                      _vm._m(11)
                    ],
                    1
                  )
                ])
              ])
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "st-Breadcrumbs" }, [
            _c("ul", { staticClass: "st-BreadcrumbsList" }, [
              _c(
                "li",
                { staticClass: "st-BreadcrumbsList_Item" },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "st-BreadcrumbsList_Item-link",
                      attrs: { to: "/" }
                    },
                    [
                      _c(
                        "p",
                        { attrs: { itemprop: "item", "aria-current": "page" } },
                        [
                          _c("span", { attrs: { itemprop: "name" } }, [
                            _vm._v("ホーム")
                          ])
                        ]
                      )
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _vm._m(12)
            ])
          ])
        ]),
        _vm._v(" "),
        _c("copyright")
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("header", { staticClass: "series-PageTitle" }, [
      _c(
        "div",
        { staticClass: "series-PageTitle_Inner", attrs: { "data-appear": "" } },
        [
          _c("h1", [
            _c("span", { staticClass: "series-PageTitle_Logo" }, [
              _vm._v("COMPANY")
            ]),
            _vm._v(" "),
            _c(
              "span",
              {
                staticClass: "series-PageTitle_Title",
                staticStyle: { color: "#FFF" }
              },
              [_vm._v("会社概要")]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "sw-parallax" }, [
            _c("div", { staticClass: "sw-parallax_outer js-parallax_outer" }, [
              _c("div", { staticClass: "sw-parallax_inner" }, [
                _c(
                  "div",
                  { staticClass: "sw-parallax_block js-parallax_block" },
                  [
                    _c("div", {
                      staticClass:
                        "sw-parallax_target promotion-PageTitle-visual",
                      staticStyle: {
                        background:
                          "url(../../../../static/img/company/COMPYANY.jpg) 50%/cover no-repeat",
                        top: "70px",
                        height: "480px"
                      }
                    })
                  ]
                )
              ])
            ])
          ])
        ]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "st-Grid_Inner-common company-profile-appear-3-1" },
      [
        _c(
          "h3",
          {
            staticClass: "sw-Section_HeaderS company-profile-appear-3",
            attrs: { "data-appear": "true" }
          },
          [
            _c("span", { staticClass: "sw-Section_HeaderS-en" }, [
              _c("b", [_vm._v("COMPANY PROFILE")])
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "sw-Section_HeaderS-ja" }, [
              _c("b", [_vm._v("会社概要")])
            ])
          ]
        )
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("dl", { staticClass: "location" }, [
      _c("dt", [_vm._v("所在地")]),
      _vm._v(" "),
      _c("dd", [
        _c("div", { staticClass: "company-Profile_List-block" }, [
          _c("div", { staticClass: "company-Profile_List-text" }, [
            _vm._v("\n                      〒105-0022"),
            _c("br"),
            _vm._v(
              "\n                      　東京都港区海岸1丁目2番20号　汐留ビルディング3階\n                    "
            )
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("dl", [
      _c("dt", [_vm._v("設立日")]),
      _vm._v(" "),
      _c("dd", [
        _c("div", { staticClass: "company-Profile_List-block" }, [
          _c("p", { staticClass: "company-Profile_List-text" }, [
            _vm._v("令和5年10月18日"),
            _c("br", { staticClass: "sp" })
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("dl", [
      _c("dt", [_vm._v("資本金")]),
      _vm._v(" "),
      _c("dd", [
        _c("div", { staticClass: "company-Profile_List-block" }, [
          _c("p", { staticClass: "company-Profile_List-text" }, [
            _vm._v("1,000万円"),
            _c("br", { staticClass: "sp" })
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("dl", [
      _c("dt", [_vm._v("代表者")]),
      _vm._v(" "),
      _c("dd", [
        _c("div", { staticClass: "company-Profile_List-block" }, [
          _c("p", { staticClass: "company-Profile_List-text" }, [
            _vm._v("代表取締役社長　劉　竑"),
            _c("br", { staticClass: "sp" })
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("dl", [
      _c("dt", [_vm._v("事業内容")]),
      _vm._v(" "),
      _c("dd", [
        _c("div", { staticClass: "company-Profile_List-block" }, [
          _c("p", { staticClass: "company-Profile_List-text" }, [
            _vm._v("システムの受託開発"),
            _c("br"),
            _vm._v(
              "\n                    ロボティクスの自動化に関する企画、開発、実施および保守のエンジニアリングサービス"
            ),
            _c("br", { staticClass: "sp" })
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("dl", [
      _c(
        "dt",
        { staticClass: "pt-md-5 pt-4", staticStyle: { display: "block" } },
        [
          _vm._v("デモセンター\n                  "),
          _c("br"),
          _c("span", { staticStyle: { color: "red" } }, [
            _vm._v("「準備中4月1日仮オープン」")
          ])
        ]
      ),
      _vm._v(" "),
      _c("dd", [
        _c("div", { staticClass: "company-Profile_List-block" }, [
          _c("p", { staticClass: "company-Profile_List-text" }, [
            _vm._v("〒332-0002"),
            _c("br"),
            _vm._v("\n                      　埼玉県川口市弥平2-15-7"),
            _c("br"),
            _vm._v("\n                      首都高速川口線加賀ICより車で5分"),
            _c("br", { staticClass: "sp" })
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("dl", [
      _c("dt", [_vm._v("主要取引銀行")]),
      _vm._v(" "),
      _c("dd", [
        _c("div", { staticClass: "company-Profile_List-block" }, [
          _c("p", { staticClass: "company-Profile_List-text" }, [
            _vm._v("みずほ銀行"),
            _c("br", { staticClass: "sp" })
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", { staticClass: "company-Profile" }, [
      _c("div", { staticClass: "company-Profile_Inner pt-0" }, [
        _c(
          "div",
          { staticClass: "st-Grid_Inner-common company-profile-appear-7-1" },
          [
            _c(
              "h3",
              {
                staticClass: "sw-Section_HeaderS company-profile-appear-7-2",
                attrs: { "data-appear": "true" }
              },
              [
                _c("span", { staticClass: "sw-Section_HeaderS-en" }, [
                  _c("b", [_vm._v("BUSINESS PARTNER")])
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "sw-Section_HeaderS-ja" }, [
                  _c("b", [_vm._v("ビジネスパートナー")])
                ])
              ]
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "company-Profile_List company-profile-appear-8",
            attrs: { "data-appear": "true" }
          },
          [
            _c("dl", [
              _c("dt", { staticClass: "text-left" }, [
                _vm._v("株式会社アースワーム")
              ]),
              _vm._v(" "),
              _c("dd", [
                _c("div", { staticClass: "company-Profile_List-block" }, [
                  _c("p", { staticClass: "company-Profile_List-text" }, [
                    _vm._v(
                      "\n                        英語名：earthworm Co., Ltd."
                    ),
                    _c("br"),
                    _c("br"),
                    _vm._v("\n                        〒１０５−００１３"),
                    _c("br"),
                    _vm._v(
                      "\n                        東京都港区浜松町２−２−１５ 浜松町ダイヤハイツ３０３号\n                      "
                    )
                  ])
                ])
              ])
            ]),
            _vm._v(" "),
            _c("dl", { staticClass: "location" }, [
              _c("dt", { staticClass: "text-left" }, [
                _vm._v("南昌阿斯旺信息技术有限责任公司\n                ")
              ]),
              _vm._v(" "),
              _c("dd", [
                _c("div", { staticClass: "company-Profile_List-block" }, [
                  _c("div", { staticClass: "company-Profile_List-text" }, [
                    _vm._v(
                      "\n                      英語名：Nanchang Asiwang Information Technology Co.,LTD."
                    ),
                    _c("br"),
                    _c("br"),
                    _vm._v("\n                      〒３３０１０３"),
                    _c("br"),
                    _vm._v(
                      "\n                      中国・江西省南昌市红谷滩区嘉言路668号语音服务中心第4层\n                    "
                    )
                  ])
                ])
              ])
            ])
          ]
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "st-Grid_Inner-common company-profile-appear-5-1" },
      [
        _c(
          "h3",
          {
            staticClass: "sw-Section_HeaderS company-profile-appear-5",
            attrs: { "data-appear": "true" }
          },
          [
            _c("span", { staticClass: "sw-Section_HeaderS-en" }, [
              _c("b", [_vm._v("ACCESS")])
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "sw-Section_HeaderS-ja" }, [
              _c("b", [_vm._v("アクセス")])
            ])
          ]
        )
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "flex-align-center" }, [
      _c("figure", [
        _c("iframe", {
          staticClass: "google-map",
          attrs: {
            src:
              "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3241.8234080266816!2d139.75672317724693!3d35.6567222313173!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x60188bc597f1d07b%3A0xee4872f5a2e303bb!2z5pel5pys44CB44CSMTA1LTAwMjIg5p2x5Lqs6YO95riv5Yy65rW35bK477yR5LiB55uu77yS4oiS77yS77yQIOaxkOeVmeODk-ODq-ODh-OCo-ODs-OCsA!5e0!3m2!1sja!2sus!4v1700028411187!5m2!1sja!2sus",
            width: "100%",
            height: "600",
            allowfullscreen: "true"
          }
        })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", { staticClass: "st-BreadcrumbsList_Item" }, [
      _c("p", { attrs: { itemprop: "item", "aria-current": "page" } }, [
        _c("span", { attrs: { itemprop: "name" } }, [_vm._v("会社情報")])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-494d4b1c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-494d4b1c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/company/profile.vue
// module id = null
// module chunks = 